import { useLocation } from "@solidjs/router";
import { type Component, createEffect, For } from "solid-js";
import { isServer } from "solid-js/web";
import { useWire } from "~/wire";
import { NotificationToast } from "./internal/NotificationToast";
import { shouldSuppressToast } from "./notificationDisplay";

export const ToastHost: Component = () => {
  const wire = useWire();
  const location = useLocation();
  const notifications = wire.notifications;

  // An activity toast for a chat already on screen is dropped before it renders;
  // it still lives in the panel list and the unread badge.
  createEffect(() => {
    for (const n of notifications.activeToasts()) {
      if (shouldSuppressToast(n, location.pathname)) notifications.dismissToast(n.id);
    }
  });

  const visibleToasts = () =>
    isServer ? [] : notifications.activeToasts().filter((n) => !shouldSuppressToast(n, location.pathname));

  return (
    <div class="pointer-events-none fixed top-4 right-4 z-100 flex flex-col gap-2" aria-live="polite">
      <For each={visibleToasts()}>{(n) => <NotificationToast notification={n} />}</For>
    </div>
  );
};
